// /app/frontend/src/utils/appSettings.ts

export interface AppSettings {
  apiWebSocketUrl: string;
  apiBaseUrl: string;
  inactivityTimeout: number;
  thankYouScreenDelay: number;
  payDeskScreenDelay: number;
  bottleScreenDelay: number;
  dataLoadingDelayMs: number;
  paymentEnabled: boolean;
  paymentTimeout: number;
  placeContainerDelay: number;
  inactivityContainerTimeout: number;
  dispensingDelay: number;
  completionScreenDelay: number;
  devDisableAutoplayVideo: boolean;
  disableWebSocket: boolean;
  defaultLanguage: string;
  // Add other settings as needed
}

// Fetch app settings from the backend taking apiEndpoint as a parameter
export const fetchAppSettings = async (apiEndpoint: string = '/api/frontend/settings/'): Promise<AppSettings> => {
  const response = await fetch(apiEndpoint);
  if (!response.ok) {
    throw new Error('Failed to fetch app settings');
  }
  const data = await response.json();
  return {
    apiWebSocketUrl: data.api_websocket_url || '',
    apiBaseUrl: data.api_base_url || '',
    inactivityTimeout: data.inactivity_timeout || 30,
    thankYouScreenDelay: data.thank_you_screen_delay || 8,
    payDeskScreenDelay: data.pay_desk_screen_delay || 4,
    bottleScreenDelay: data.bottle_screen_delay || 4,
    dataLoadingDelayMs: data.data_loading_delay_ms || 500,
    paymentEnabled: data.payment_enabled,
    paymentTimeout: data.payment_timeout || 40,
    placeContainerDelay: data.place_container_delay || 10,
    inactivityContainerTimeout: data.inactivity_container_timeout || 60,
    dispensingDelay: data.dispensing_delay || 15,
    completionScreenDelay: data.completion_screen_delay || 10,
    devDisableAutoplayVideo: data.dev_disable_autoplay_video,
    disableWebSocket: data.disable_websocket,
    defaultLanguage: data.default_language || 'en',
  };
};

// Load default settings if the API endpoint fails
export const loadDefaultAppSettings = (): AppSettings => {
  return {
    apiWebSocketUrl: '/ws/refill_station/',
    apiBaseUrl: '',
    inactivityTimeout: 30,
    thankYouScreenDelay: 8,
    payDeskScreenDelay: 4,
    bottleScreenDelay: 4,
    dataLoadingDelayMs: 500,
    paymentEnabled: true,
    paymentTimeout: 40,
    placeContainerDelay: 10,
    inactivityContainerTimeout: 60,
    dispensingDelay: 15,
    completionScreenDelay: 10,
    devDisableAutoplayVideo: false,
    disableWebSocket: false,
    defaultLanguage: 'en',
  };
};

// Load settings for demo mode
export const loadDemoAppSettings = (): AppSettings => {
  return {
    apiWebSocketUrl: '/ws/refill_station/',
    apiBaseUrl: '',
    inactivityTimeout: 30,
    thankYouScreenDelay: 8,
    payDeskScreenDelay: 4,
    bottleScreenDelay: 4,
    dataLoadingDelayMs: 500,
    paymentEnabled: true,
    paymentTimeout: 40,
    placeContainerDelay: 10,
    inactivityContainerTimeout: 60,
    dispensingDelay: 15,
    completionScreenDelay: 10,
    devDisableAutoplayVideo: false,
    disableWebSocket: true,
    defaultLanguage: 'en',
  };
};
